import type { LifeDimensions } from '../domain/life-state'
import { ParticleMyceliumRenderer } from './particle-mycelium-renderer'

export interface LifeRendererInput {
  x: number
  y: number
  force: number
  speed?: number
  active?: boolean
}

export interface LifeRenderer {
  setState(dimensions: LifeDimensions): void
  setInput(input: LifeRendererInput): void
  start(): void
  stop(): void
  dispose(): void
}

export function createLifeRenderer(
  canvas: HTMLCanvasElement,
  options: { seed: string; reducedMotion?: () => boolean } = {
    seed: 'global:embryonic',
  },
): LifeRenderer {
  try {
    return new ParticleMyceliumRenderer(canvas, options)
  } catch {
    return {
      setState: () => undefined,
      setInput: () => undefined,
      start: () => undefined,
      stop: () => undefined,
      dispose: () => undefined,
    }
  }
}
